import { BusinessUnitItemSchema } from "@/schemas/business-unit/business-unit-item";
import { ProductItemSchema } from "@/schemas/product/product-item";
import { z } from "zod";

export const SubscriptionAssignmentSchema = z.object({
  Id: z.string().uuid(),
  DateInstalled: z.string().optional(),
  DatePaid: z.string().optional(),
  DateSold: z.string().optional(),
  DateStarted: z.string().optional(),
  DateStopped: z.string().optional(),
  InvoiceCreated: z.boolean().optional(),
  InvoiceSent: z.boolean().optional(),
  Name: z.string().optional(),
  IsPaid: z.boolean().optional(),
  PaidStatusCode: z.number().optional(),
  PetrosoftCloudId: z.string().optional(),
  ProductStatusCode: z.number().optional(),
  ProductStatusName: z.string().optional(),
  Quantity: z.number().optional(),
  SalesChannelCode: z.number().optional(),
  Unit: z.string().optional(),
  StatusCode: z.number().optional(),
  ProductId: ProductItemSchema.shape.Id.optional(),
  ProductName: z.string().optional(),
  BusinessUnitId: BusinessUnitItemSchema.shape.Id.optional(),
  BusinessUnitName: z.string().optional(),
  ActivatedById: z.string().uuid().optional(),
  ActivatedByName: z.string().optional(),
  SalesOrderId: z.string().uuid().optional(),
  PurchasedProductId: z.string().uuid().optional(),
  IsInstalled: z.boolean().optional(),
  IsNotInstalled: z.boolean().optional(),
});

export type SubscriptionAssignmentType = z.infer<
  typeof SubscriptionAssignmentSchema
>;
